import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class GitFetchGitError extends GitError {
  constructor() {
    super(`Failed to fetch repository status`);
  }

  readonly gitErrorCode = GitErrorStatusCode.GitFetch;
}
